import "./styles.css";
import { cityName } from "./scripts/cityAutocomplete.js";
import { listeners } from "./scripts/listeners.js";

listeners();
cityName();